// @flow
import type { Epic } from '../../../annotations';
import type { SendAnalytics } from '../../../core/ga';

import * as r from 'ramda';
import { select } from 'redux-most';
import { actionTypes } from 'redux-form';
import * as mostc from '../../../crosscutting/mostc';
import { ignoreElements } from 'most-adjunct';

const resetFiltersEpic = (
  sendAnalytics: SendAnalytics,
): Epic => (actions$) => r.pipe(
  select(actionTypes.RESET),
  mostc.filter(({
    meta,
  }) => meta.form === 'domainFilters'),
  mostc.tap(() => {
    sendAnalytics({
      hitType: 'event',
      eventCategory: 'Filters',
      eventAction: 'reset',
    });
  }),
  ignoreElements,
)(actions$);

export default resetFiltersEpic;
